// Service Providers Database - Northeast US Focus
// Curated list of vetted specialists for exotic, classic, and collector vehicles

export const SERVICE_CATEGORIES = [
  { id: 'all', label: 'All Services', icon: 'Cog' },
  { id: 'transport', label: 'Transport & Logistics', icon: 'Truck' },
  { id: 'ppf', label: 'PPF & Detailing', icon: 'Shield' },
  { id: 'mechanical', label: 'Mechanical Service', icon: 'Wrench' },
  { id: 'bodywork', label: 'Body & Paint', icon: 'Paintbrush' },
  { id: 'restoration', label: 'Restoration', icon: 'Car' },
  { id: 'storage', label: 'Storage Facilities', icon: 'Warehouse' },
  { id: 'performance', label: 'Performance & Tuning', icon: 'Gauge' },
  { id: 'upholstery', label: 'Upholstery & Interior', icon: 'Armchair' },
  { id: 'electrical', label: 'Electrical & Electronics', icon: 'Zap' }
]

export const BRAND_SPECIALTIES = [
  'Porsche', 'Ferrari', 'Lamborghini', 'Mercedes-Benz', 'BMW',
  'Audi', 'Land Rover', 'Jaguar', 'Aston Martin', 'McLaren',
  'Bentley', 'Rolls-Royce', 'Classic American', 'British Classics',
  'Japanese Imports', 'Alfa Romeo', 'Maserati'
]

export const REGIONS = [
  { id: 'hudson-valley', label: 'Hudson Valley, NY', lat: 41.7004, lng: -73.9209 },
  { id: 'westchester', label: 'Westchester County, NY', lat: 41.1220, lng: -73.7949 },
  { id: 'connecticut', label: 'Connecticut', lat: 41.6032, lng: -73.0877 },
  { id: 'new-jersey', label: 'New Jersey', lat: 40.0583, lng: -74.4057 },
  { id: 'long-island', label: 'Long Island, NY', lat: 40.7891, lng: -73.1350 },
  { id: 'nyc', label: 'New York City', lat: 40.7128, lng: -74.0060 },
  { id: 'massachusetts', label: 'Massachusetts', lat: 42.4072, lng: -71.3824 },
  { id: 'pennsylvania', label: 'Eastern Pennsylvania', lat: 40.2732, lng: -76.8867 },
  { id: 'maine', label: 'Maine', lat: 44.6939, lng: -69.3819 },
  { id: 'new-hampshire', label: 'New Hampshire', lat: 43.4525, lng: -71.3106 },
  { id: 'vermont', label: 'Vermont', lat: 44.0459, lng: -72.7107 },
  { id: 'rhode-island', label: 'Rhode Island', lat: 41.6809, lng: -71.5119 },
  { id: 'albany-ny', label: 'Albany, NY', lat: 42.6526, lng: -73.7562 },
  { id: 'syracuse-ny', label: 'Syracuse, NY', lat: 43.0481, lng: -76.1474 },
  { id: 'rochester-ny', label: 'Rochester, NY', lat: 43.1614, lng: -77.6109 },
  { id: 'central-nj', label: 'Central New Jersey', lat: 40.2206, lng: -74.7597 },
  { id: 'south-nj', label: 'Southern New Jersey', lat: 39.5501, lng: -74.4204 }
]

// Service providers are now stored in the Supabase database (service_providers table).
// This static array is kept as a fallback only and should not be used for new features.
// Use getServiceProviders() from supabase.js instead.
export const SERVICE_PROVIDERS = [
  // === FERRARI SPECIALISTS ===
  {
    id: 'wide-world-ferrari',
    name: 'Wide World Ferrari',
    category: 'mechanical',
    description: 'Authorized Ferrari dealer with factory-trained technicians. Full service department handling everything from routine maintenance to major engine work. Known for excellent customer service and transparent pricing.',
    location: 'Spring Valley, NY',
    region: 'hudson-valley',
    coordinates: { lat: 41.1132, lng: -74.0440 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: true,
    specialties: ['Ferrari'],
    services: ['Factory Service', 'Major Repairs', 'Pre-Purchase Inspection', 'Warranty Work'],
    phone: '(845) 425-3500',
    website: 'https://www.wideworldferrari.com',
    priceRange: '$$$$',
    notes: 'Authorized dealer - best for warranty work and newer Ferraris'
  },
  {
    id: 'cantech-automotive',
    name: 'Cantech Automotive',
    category: 'mechanical',
    description: 'Independent Ferrari and exotic specialist with over 30 years experience. Lower rates than dealer with same quality work. Specialists in classic Ferraris including Testarossa, 348, and F355.',
    location: 'Englewood Cliffs, NJ',
    region: 'new-jersey',
    coordinates: { lat: 40.8854, lng: -73.9526 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: true,
    specialties: ['Ferrari', 'Maserati', 'Lamborghini'],
    services: ['Complete Service', 'Engine Rebuilds', 'Timing Belt Service', 'Clutch Replacement'],
    phone: '(201) 568-0055',
    website: 'https://www.cantechautomotive.com',
    priceRange: '$$$',
    notes: 'Highly recommended on FerrariChat forums for classic Ferrari work'
  },
  {
    id: 'exoticars-usa',
    name: 'Exoticars USA',
    category: 'mechanical',
    description: 'Ferrari, Lamborghini, and Maserati specialists serving the tri-state area. Family-owned shop known for honest assessments and quality work at fair prices.',
    location: 'Saddle Brook, NJ',
    region: 'new-jersey',
    coordinates: { lat: 40.9023, lng: -74.0926 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: false,
    specialties: ['Ferrari', 'Lamborghini', 'Maserati'],
    services: ['Routine Maintenance', 'Major Service', 'Diagnostics', 'Performance Upgrades'],
    phone: '(201) 843-8700',
    website: 'https://www.exoticarsusa.com',
    priceRange: '$$$',
    notes: 'Good alternative to dealer for out-of-warranty cars'
  },
  {
    id: 'j-scuderia',
    name: 'J. Scuderia',
    category: 'mechanical',
    description: 'Boutique Ferrari service facility run by former dealer technicians. Meticulous attention to detail. Specializes in vintage and modern Ferrari maintenance.',
    location: 'Parsippany, NJ',
    region: 'new-jersey',
    coordinates: { lat: 40.8576, lng: -74.4258 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: true,
    specialties: ['Ferrari'],
    services: ['Concours Prep', 'Major Service', 'Sorting', 'Documentation'],
    phone: '(973) 984-1444',
    website: 'https://www.jscuderia.com',
    priceRange: '$$$$',
    notes: 'Known for perfectionist approach - ideal for collector cars'
  },

  // === PORSCHE SPECIALISTS ===
  {
    id: 'repasi-motorwerks',
    name: 'Repasi Motorwerks',
    category: 'mechanical',
    description: 'Premier independent Porsche specialist in Westchester. Known for honest advice and exceptional work quality. Expertise in air-cooled and modern water-cooled Porsches.',
    location: 'Armonk, NY',
    region: 'westchester',
    coordinates: { lat: 41.1265, lng: -73.7143 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: true,
    specialties: ['Porsche'],
    services: ['IMS Bearing Replacement', 'Engine Rebuilds', 'Routine Service', 'Track Prep'],
    phone: '(914) 273-4242',
    website: 'https://www.repasimotorwerks.com',
    priceRange: '$$$',
    notes: 'Universally praised on Rennlist forums - top choice for Westchester area'
  },
  {
    id: 'musante-motorsports',
    name: 'Musante Motorsports',
    category: 'mechanical',
    description: 'Elite Porsche service and performance shop. Extensive experience with GT cars, track preparation, and high-performance builds. Former Porsche Cup mechanics on staff.',
    location: 'Wallingford, CT',
    region: 'connecticut',
    coordinates: { lat: 41.4570, lng: -72.8231 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: true,
    specialties: ['Porsche'],
    services: ['Track Prep', 'Performance Builds', 'Engine Rebuilds', 'GT3/GT4 Service'],
    phone: '(203) 269-6640',
    website: 'https://www.musantemotorsports.com',
    priceRange: '$$$$',
    notes: 'Go-to shop for serious Porsche track enthusiasts in the Northeast'
  },
  {
    id: 'precision-porsche',
    name: 'Precision Porsche',
    category: 'mechanical',
    description: 'Long-established Porsche specialist serving the Hudson Valley. Honest diagnostics and fair pricing. Good for routine maintenance and general repairs.',
    location: 'Poughkeepsie, NY',
    region: 'hudson-valley',
    coordinates: { lat: 41.7004, lng: -73.9209 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: false,
    specialties: ['Porsche'],
    services: ['Routine Maintenance', 'Brake Service', 'Suspension', 'Diagnostics'],
    phone: '(845) 454-4900',
    website: null,
    priceRange: '$$',
    notes: 'Good local option for routine Porsche service'
  },
  {
    id: 'pts-automotive',
    name: 'PTS Automotive',
    category: 'mechanical',
    description: 'Porsche and German car specialists with state-of-the-art facility. PIWIS diagnostics and factory-level tooling. Known for thorough pre-purchase inspections.',
    location: 'Bedford Hills, NY',
    region: 'westchester',
    coordinates: { lat: 41.2365, lng: -73.6929 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: false,
    specialties: ['Porsche', 'BMW', 'Mercedes-Benz'],
    services: ['Pre-Purchase Inspection', 'Major Service', 'Electrical Diagnostics', 'AC Service'],
    phone: '(914) 241-5820',
    website: 'https://www.ptsautomotive.com',
    priceRange: '$$$',
    notes: 'Excellent for PPIs before purchasing'
  },

  // === BMW/MERCEDES SPECIALISTS ===
  {
    id: 'eurotech-motors',
    name: 'EuroTech Motors',
    category: 'mechanical',
    description: 'BMW and Mercedes specialists with factory-level equipment. Known for tackling complex electrical issues. Former dealer techs with decades of experience.',
    location: 'White Plains, NY',
    region: 'westchester',
    coordinates: { lat: 41.0340, lng: -73.7629 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: true,
    specialties: ['BMW', 'Mercedes-Benz'],
    services: ['Engine Service', 'Electrical Repair', 'Diagnostics', 'Performance Upgrades'],
    phone: '(914) 946-3750',
    website: 'https://www.eurotechmotors.com',
    priceRange: '$$$',
    notes: 'Highly recommended on Bimmerpost - excellent for complex repairs'
  },
  {
    id: 'bimmers-r-us',
    name: 'Bimmers R Us',
    category: 'mechanical',
    description: 'Independent BMW specialist with competitive pricing. Specializes in E30, E36, E46, and newer models. Good for both maintenance and modifications.',
    location: 'Hawthorne, NJ',
    region: 'new-jersey',
    coordinates: { lat: 40.9493, lng: -74.1538 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: false,
    specialties: ['BMW'],
    services: ['Routine Service', 'Performance Mods', 'Suspension', 'Brake Upgrades'],
    phone: '(973) 423-0909',
    website: 'https://www.bimmersrus.com',
    priceRange: '$$',
    notes: 'Good value option for BMW service'
  },

  // === LAND ROVER SPECIALISTS ===
  {
    id: 'atlantic-british',
    name: 'Atlantic British',
    category: 'mechanical',
    description: 'The definitive Land Rover parts and service destination in the Northeast. Massive parts inventory and expert technicians. Serves Defender, Discovery, Range Rover.',
    location: 'Mechanicville, NY',
    region: 'hudson-valley',
    coordinates: { lat: 42.9034, lng: -73.6868 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: true,
    specialties: ['Land Rover'],
    services: ['Full Service', 'Parts Sales', 'Restoration', 'Upgrades'],
    phone: '(800) 533-2210',
    website: 'https://www.atlanticbritish.com',
    priceRange: '$$',
    notes: 'THE go-to for Land Rover in the Northeast - also ships parts nationwide'
  },
  {
    id: 'rovers-north',
    name: 'Rovers North',
    category: 'restoration',
    description: 'Land Rover restoration specialists focusing on classic Defenders and Series vehicles. Complete frame-off restorations and parts sourcing.',
    location: 'Westford, VT',
    region: 'massachusetts',
    coordinates: { lat: 44.6145, lng: -73.0060 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: true,
    specialties: ['Land Rover'],
    services: ['Full Restoration', 'Parts Sales', 'Rust Repair', 'Mechanical Rebuild'],
    phone: '(802) 879-0032',
    website: 'https://www.roversnorth.com',
    priceRange: '$$$$',
    notes: 'Premier Defender restoration shop - worth the trip from anywhere'
  },
  {
    id: 'm-spec-performance',
    name: 'M-Spec Performance',
    category: 'performance',
    description: 'Modern Land Rover and Range Rover specialists. Performance upgrades, off-road builds, and service for newer models.',
    location: 'Fairfield, CT',
    region: 'connecticut',
    coordinates: { lat: 41.1408, lng: -73.2637 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: false,
    specialties: ['Land Rover'],
    services: ['Performance Tuning', 'Suspension Lifts', 'Exhaust', 'Diagnostics'],
    phone: '(203) 254-7778',
    website: 'https://www.mspecperformance.com',
    priceRange: '$$$',
    notes: 'Good for modern Range Rover Sport and Discovery upgrades'
  },

  // === BRITISH CAR SPECIALISTS ===
  {
    id: 'briarcliff-imported',
    name: 'Briarcliff Classic Imported Auto',
    category: 'mechanical',
    description: 'Jaguar, Aston Martin, and British car specialists with over 40 years experience. Deep knowledge of classic British marques. Also services modern Jaguars.',
    location: 'Briarcliff Manor, NY',
    region: 'westchester',
    coordinates: { lat: 41.1457, lng: -73.8237 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: true,
    specialties: ['Jaguar', 'Aston Martin', 'British Classics'],
    services: ['Complete Service', 'Electrical Repair', 'Carb Tuning', 'Brake Service'],
    phone: '(914) 762-8808',
    website: null,
    priceRange: '$$$',
    notes: 'Old-school expertise for classic British cars'
  },
  {
    id: 'sports-and-classics',
    name: 'Sports & Classics',
    category: 'restoration',
    description: 'Aston Martin and British sports car restoration specialists. Known for concours-quality restorations of DB series Astons and E-Type Jaguars.',
    location: 'Darien, CT',
    region: 'connecticut',
    coordinates: { lat: 41.0779, lng: -73.4696 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: true,
    specialties: ['Aston Martin', 'Jaguar', 'British Classics'],
    services: ['Frame-Off Restoration', 'Mechanical Rebuild', 'Body/Paint', 'Upholstery'],
    phone: '(203) 655-6510',
    website: 'https://www.sportsandclassics.com',
    priceRange: '$$$$',
    notes: 'Museum-quality Aston Martin restorations'
  },

  // === PPF & DETAILING ===
  {
    id: 'distinctive-detailing',
    name: 'Distinctive Detailing',
    category: 'ppf',
    description: 'XPEL certified installer specializing in exotic and collector vehicles. Full PPF wraps, ceramic coatings, and paint correction. Climate-controlled facility.',
    location: 'Greenwich, CT',
    region: 'connecticut',
    coordinates: { lat: 41.0262, lng: -73.6282 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: true,
    specialties: ['Ferrari', 'Porsche', 'Lamborghini', 'McLaren'],
    services: ['Full PPF Wrap', 'Ceramic Coating', 'Paint Correction', 'Interior Protection'],
    phone: '(203) 869-5445',
    website: 'https://www.distinctivedetailingct.com',
    priceRange: '$$$$',
    notes: 'Top choice for Greenwich/Westchester exotic car owners'
  },
  {
    id: 'prestige-car-wash',
    name: 'Prestige Car Wash & Detail',
    category: 'ppf',
    description: 'Full-service detailing and PPF installation. Known for handling high-end vehicles with care. XPEL and Ceramic Pro certified.',
    location: 'Bedford Hills, NY',
    region: 'westchester',
    coordinates: { lat: 41.2365, lng: -73.6929 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: false,
    specialties: ['Porsche', 'BMW', 'Mercedes-Benz'],
    services: ['PPF Installation', 'Ceramic Coating', 'Detail Packages', 'Window Tint'],
    phone: '(914) 666-5550',
    website: 'https://www.prestigecarwashny.com',
    priceRange: '$$$',
    notes: 'Good mid-range option for PPF in Westchester'
  },
  {
    id: 'darien-detail',
    name: 'Darien Detail',
    category: 'ppf',
    description: 'Boutique detailing studio serving Fairfield County. Expert paint correction and ceramic coatings. Individual attention to each vehicle.',
    location: 'Darien, CT',
    region: 'connecticut',
    coordinates: { lat: 41.0779, lng: -73.4696 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: false,
    specialties: ['Ferrari', 'Porsche', 'Bentley', 'Rolls-Royce'],
    services: ['Paint Correction', 'Ceramic Coating', 'Interior Detail', 'Show Prep'],
    phone: '(203) 655-7225',
    website: 'https://www.dariendetail.com',
    priceRange: '$$$$',
    notes: 'Excellent for concours preparation'
  },
  {
    id: 'film-doctors',
    name: 'The Film Doctors',
    category: 'ppf',
    description: 'Paint protection film specialists with custom template cutting. STEK and XPEL certified. Known for flawless installations on complex bodywork.',
    location: 'Stamford, CT',
    region: 'connecticut',
    coordinates: { lat: 41.0534, lng: -73.5387 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: true,
    specialties: ['Lamborghini', 'McLaren', 'Porsche', 'Ferrari'],
    services: ['Full PPF Wrap', 'Partial PPF', 'Custom Cuts', 'Headlight Protection'],
    phone: '(203) 348-9400',
    website: 'https://www.thefilmdoctors.com',
    priceRange: '$$$$',
    notes: 'Specialists in complex curves and exotic bodywork'
  },

  // === ENCLOSED TRANSPORT ===
  {
    id: 'intercity-lines',
    name: 'Intercity Lines',
    category: 'transport',
    description: 'Premium enclosed auto transport serving the entire US. Air-ride suspension trailers with lift gates. White glove service for collector and exotic vehicles.',
    location: 'Warren, MA',
    region: 'massachusetts',
    coordinates: { lat: 42.2126, lng: -72.1912 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: true,
    specialties: ['Ferrari', 'Porsche', 'Classic American', 'Lamborghini'],
    services: ['Enclosed Transport', 'Door-to-Door', 'Auction Delivery', 'Show Transport'],
    phone: '(800) 221-3936',
    website: 'https://www.intercitylines.com',
    priceRange: '$$$$',
    notes: 'Industry leader - used by auction houses and museums'
  },
  {
    id: 'reliable-carriers',
    name: 'Reliable Carriers',
    category: 'transport',
    description: 'One of the largest enclosed car transport companies. GPS tracking, insurance included, professional drivers with exotic car experience.',
    location: 'Canton, MI (serves Northeast)',
    region: 'hudson-valley',
    coordinates: { lat: 42.3087, lng: -83.4821 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: true,
    specialties: ['Ferrari', 'Porsche', 'Lamborghini', 'McLaren'],
    services: ['Enclosed Transport', 'Open Transport', 'International Shipping', 'Storage'],
    phone: '(800) 521-6393',
    website: 'https://www.reliablecarriers.com',
    priceRange: '$$$',
    notes: 'Nationwide coverage with regular Northeast routes'
  },
  {
    id: 'exotic-car-transport',
    name: 'Exotic Car Transport',
    category: 'transport',
    description: 'Boutique enclosed transport service specializing in supercars and rare collectibles. Owner-operated with meticulous attention to detail.',
    location: 'Ronkonkoma, NY',
    region: 'long-island',
    coordinates: { lat: 40.8151, lng: -73.1151 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: false,
    specialties: ['Lamborghini', 'Ferrari', 'McLaren', 'Bugatti'],
    services: ['Enclosed Transport', 'Event Transport', 'Track Day Logistics'],
    phone: '(631) 737-0707',
    website: 'https://www.exoticcartransport.com',
    priceRange: '$$$$',
    notes: 'Local Long Island option - great for NYC area'
  },

  // === RESTORATION SHOPS ===
  {
    id: 'radley-enterprises',
    name: 'Radley Enterprises',
    category: 'restoration',
    description: 'Premier classic car restoration facility. Specializes in American muscle cars, particularly Corvettes. Full frame-off restorations and mechanical rebuilds.',
    location: 'Poughkeepsie, NY',
    region: 'hudson-valley',
    coordinates: { lat: 41.7004, lng: -73.9209 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: true,
    specialties: ['Classic American', 'Corvette'],
    services: ['Frame-Off Restoration', 'Engine Rebuild', 'Body/Paint', 'Chrome'],
    phone: '(845) 471-7010',
    website: 'https://www.radleyenterprises.com',
    priceRange: '$$$$',
    notes: 'Hudson Valley gem for American classic restoration'
  },
  {
    id: 'paradigm-auto',
    name: 'Paradigm Auto Restoration',
    category: 'restoration',
    description: 'European classic car restoration specialists. Known for Mercedes-Benz 300SL, vintage Porsche, and pre-war classics.',
    location: 'Stamford, CT',
    region: 'connecticut',
    coordinates: { lat: 41.0534, lng: -73.5387 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: true,
    specialties: ['Mercedes-Benz', 'Porsche', 'British Classics'],
    services: ['Concours Restoration', 'Preservation', 'Mechanical Service', 'Documentation'],
    phone: '(203) 324-7440',
    website: 'https://www.paradigmauto.com',
    priceRange: '$$$$',
    notes: 'Museum-quality work on significant European classics'
  },
  {
    id: 'gullwing-motor-cars',
    name: 'Gullwing Motor Cars',
    category: 'restoration',
    description: 'Mercedes-Benz specialists from the 1950s-1980s. Full restoration services and a renowned inventory of cars for sale. Deep expertise in 300SL and Pagoda.',
    location: 'Astoria, NY',
    region: 'nyc',
    coordinates: { lat: 40.7644, lng: -73.9235 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: true,
    specialties: ['Mercedes-Benz'],
    services: ['Full Restoration', 'Service', 'Parts', 'Sales'],
    phone: '(718) 545-0500',
    website: 'https://www.gullwingmotorcars.com',
    priceRange: '$$$$',
    notes: 'The name in vintage Mercedes restoration'
  },

  // === UPHOLSTERY & INTERIOR ===
  {
    id: 'supreme-seams',
    name: 'Supreme Seams',
    category: 'upholstery',
    description: 'Custom automotive upholstery specializing in exotic and classic cars. Connolly leather, original patterns, and concours-quality work.',
    location: 'Yonkers, NY',
    region: 'westchester',
    coordinates: { lat: 40.9312, lng: -73.8987 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: true,
    specialties: ['Ferrari', 'Porsche', 'Classic American'],
    services: ['Full Interior', 'Seat Repair', 'Convertible Tops', 'Carpet'],
    phone: '(914) 965-2800',
    website: null,
    priceRange: '$$$',
    notes: 'Old-world craftsmanship - Ferrari club favorite'
  },
  {
    id: 'bright-ideas',
    name: 'Bright Ideas Auto Upholstery',
    category: 'upholstery',
    description: 'Full-service upholstery shop with expertise in classic and exotic interiors. Custom work and period-correct restorations.',
    location: 'Danbury, CT',
    region: 'connecticut',
    coordinates: { lat: 41.3948, lng: -73.4540 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: false,
    specialties: ['Classic American', 'British Classics', 'Porsche'],
    services: ['Full Interior', 'Leather Repair', 'Headliner', 'Door Panels'],
    phone: '(203) 748-4777',
    website: 'https://www.brightideasupholstery.com',
    priceRange: '$$',
    notes: 'Good value option in CT'
  },

  // === STORAGE FACILITIES ===
  {
    id: 'autobahn-indoor-speedway',
    name: 'Autobahn Secure Storage',
    category: 'storage',
    description: 'Climate-controlled collector car storage with 24/7 security. Battery maintainers, periodic starting, and detailing services available.',
    location: 'White Plains, NY',
    region: 'westchester',
    coordinates: { lat: 41.0340, lng: -73.7629 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: true,
    specialties: [],
    services: ['Climate Control', 'Battery Maintenance', 'Weekly Starting', 'Detailing'],
    phone: '(914) 821-7625',
    website: 'https://www.autobahnsecure.com',
    priceRange: '$$$',
    notes: 'Premium Westchester storage option'
  },
  {
    id: 'classic-car-storage',
    name: 'Classic Car Storage of Greenwich',
    category: 'storage',
    description: 'Exclusive climate-controlled facility for collector vehicles. Individual enclosed spaces, weekly inspection, and concierge services.',
    location: 'Greenwich, CT',
    region: 'connecticut',
    coordinates: { lat: 41.0262, lng: -73.6282 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: true,
    specialties: [],
    services: ['Private Suites', 'Climate Control', 'Concierge', 'Transport Coordination'],
    phone: '(203) 869-1500',
    website: null,
    priceRange: '$$$$',
    notes: 'Ultra-premium storage for discerning collectors'
  },

  // === PERFORMANCE & TUNING ===
  {
    id: 'race-technik',
    name: 'Race Technik',
    category: 'performance',
    description: 'Porsche performance specialists with track experience. Custom builds, suspension setup, and race prep for GT3, GT4, and Cup cars.',
    location: 'Stratford, CT',
    region: 'connecticut',
    coordinates: { lat: 41.1845, lng: -73.1332 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: true,
    specialties: ['Porsche'],
    services: ['Track Prep', 'Suspension Setup', 'Roll Cages', 'Safety Equipment'],
    phone: '(203) 378-0808',
    website: 'https://www.racetechnik.com',
    priceRange: '$$$$',
    notes: 'Where serious Porsche track junkies go'
  },
  {
    id: 'tuned-motorsports',
    name: 'TUNED Motorsports',
    category: 'performance',
    description: 'European performance specialists with dyno facility. ECU tuning, exhaust, and intake modifications for BMW, Audi, and Mercedes.',
    location: 'Englewood, NJ',
    region: 'new-jersey',
    coordinates: { lat: 40.8929, lng: -73.9726 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: false,
    specialties: ['BMW', 'Audi', 'Mercedes-Benz'],
    services: ['ECU Tuning', 'Dyno Testing', 'Exhaust', 'Intake'],
    phone: '(201) 569-8600',
    website: 'https://www.tunedmotorsports.com',
    priceRange: '$$$',
    notes: 'Good for modern German performance cars'
  },

  // === ELECTRICAL SPECIALISTS ===
  {
    id: 'classic-auto-electric',
    name: 'Classic Auto Electric',
    category: 'electrical',
    description: 'Vintage car electrical specialists. Lucas, Bosch, and Magneti Marelli expertise. Alternator conversions and complete rewiring.',
    location: 'Carmel, NY',
    region: 'hudson-valley',
    coordinates: { lat: 41.4298, lng: -73.6801 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: true,
    specialties: ['British Classics', 'Italian Classics', 'Classic American'],
    services: ['Complete Rewiring', 'Alternator Conversion', 'Gauge Repair', 'Starter Rebuild'],
    phone: '(845) 228-8700',
    website: null,
    priceRange: '$$',
    notes: 'Solves the electrical gremlins others give up on'
  },

  // === BODY & PAINT ===
  {
    id: 'color-concepts',
    name: 'Color Concepts',
    category: 'bodywork',
    description: 'High-end collision repair and custom paint for exotic vehicles. PPG certified refinish facility. Known for perfect color matching.',
    location: 'Mount Kisco, NY',
    region: 'westchester',
    coordinates: { lat: 41.2040, lng: -73.7271 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: true,
    specialties: ['Ferrari', 'Porsche', 'Lamborghini', 'McLaren'],
    services: ['Collision Repair', 'Custom Paint', 'Show Finish', 'Color Matching'],
    phone: '(914) 666-5858',
    website: 'https://www.colorconcepts.com',
    priceRange: '$$$$',
    notes: 'Insurance-approved but enthusiast quality'
  },
  {
    id: 'perfect-finish',
    name: 'Perfect Finish Auto Body',
    category: 'bodywork',
    description: 'Full-service body shop with exotic car experience. Frame straightening, panel repair, and complete refinishing.',
    location: 'Danbury, CT',
    region: 'connecticut',
    coordinates: { lat: 41.3948, lng: -73.4540 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: false,
    specialties: ['Porsche', 'BMW', 'Mercedes-Benz'],
    services: ['Collision Repair', 'Dent Removal', 'Paint', 'Frame Repair'],
    phone: '(203) 744-4800',
    website: 'https://www.perfectfinishct.com',
    priceRange: '$$$',
    notes: 'Good mid-range option in CT'
  },

  // === MAINE ===
  {
    id: 'maine-luxury-auto-barn',
    name: 'Maine Luxury Auto Barn',
    category: 'mechanical',
    description: 'BMW and Mini specialist with factory-trained master technician. Expert in German luxury vehicles with meticulous attention to detail.',
    location: 'Biddeford, ME',
    region: 'maine',
    coordinates: { lat: 43.4748, lng: -70.3160 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: false,
    specialties: ['BMW', 'Mini Cooper'],
    services: ['Factory Service', 'Diagnostic Repair', 'Maintenance', 'Performance Upgrades'],
    phone: '(207) 406-9517',
    website: 'https://maineluxuryautobarn.com',
    priceRange: '$$$',
    notes: 'Factory-trained master tech specializing in BMW/Mini'
  },
  {
    id: 'vp-automotive-llc',
    name: 'VP Automotive LLC',
    category: 'mechanical',
    description: 'Foreign vehicle specialist with 20+ years experience. Expertise in European luxury and performance cars including Audi, VW, BMW, Porsche, and Mercedes.',
    location: 'Portland, ME',
    region: 'maine',
    coordinates: { lat: 43.6629, lng: -70.2557 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: false,
    specialties: ['Audi', 'VW', 'BMW', 'Porsche', 'Mercedes-Benz'],
    services: ['Full Service', 'Diagnostics', 'Major Repairs', 'Performance Work'],
    phone: null,
    website: 'https://vpautomotivellc.com',
    priceRange: '$$',
    notes: 'Generalist European specialist with 20+ years experience'
  },
  {
    id: 'portland-performance-llc',
    category: 'performance',
    name: 'Portland Performance LLC',
    description: 'Performance shop specializing in engine builds, ceramic coatings, and classic muscle car restoration. Climate-controlled storage available.',
    location: 'Portland, ME',
    region: 'maine',
    coordinates: { lat: 43.6629, lng: -70.2557 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: false,
    specialties: ['Classic American', 'European'],
    services: ['Engine Builds', 'Ceramic Coatings', 'Storage', 'Restoration'],
    phone: '(207) 517-5555',
    website: 'https://portlandperformance.com',
    priceRange: '$$',
    notes: 'Engine builds and performance work with storage available'
  },
  {
    id: 'portland-motor-club',
    name: 'Portland Motor Club',
    category: 'storage',
    description: 'Climate-controlled and secure car storage facility. Ideal for collector vehicles requiring protection from weather and theft.',
    location: 'Portland, ME',
    region: 'maine',
    coordinates: { lat: 43.6629, lng: -70.2557 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: false,
    specialties: [],
    services: ['Climate-Controlled Storage', 'Security', '24/7 Monitoring'],
    phone: null,
    website: 'https://portlandmotorclub.com',
    priceRange: '$$$',
    notes: 'Climate-controlled secure storage for all vehicles'
  },
  {
    id: 'baxleys-speed-shop',
    name: 'Baxleys Speed Shop',
    category: 'performance',
    description: 'Dyno tuning and race car fabrication specialists. Full performance shop with expertise in hot rods and race vehicles.',
    location: 'Windham, ME',
    region: 'maine',
    coordinates: { lat: 43.8397, lng: -70.4500 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: false,
    specialties: ['Performance/Race Vehicles', 'Classic American'],
    services: ['Dyno Tuning', 'Race Car Fabrication', 'Engine Work', 'Custom Builds'],
    phone: '(207) 572-1119',
    website: 'https://baxleysspeedshop.com',
    priceRange: '$$$',
    notes: 'Dyno tuning and race car fabrication specialist'
  },

  // === NEW HAMPSHIRE ===
  {
    id: 'northeast-detailing',
    name: 'Northeast Detailing',
    category: 'ppf',
    description: '#1 Detail Shop in New Hampshire since 2007. XPEL and Opti-Coat certified installer providing premium paint protection and ceramic coatings.',
    location: 'Hooksett, NH',
    region: 'new-hampshire',
    coordinates: { lat: 43.2058, lng: -71.4688 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: true,
    specialties: [],
    services: ['PPF Installation', 'Ceramic Coating', 'Paint Correction', 'Opti-Coat'],
    phone: '(603) 668-1881',
    website: 'https://northeastdetailing.com',
    priceRange: '$$$',
    notes: '#1 Detail Shop in NH since 2007 - Opti-Coat installer'
  },
  {
    id: 'ims-detailing',
    name: 'IMS Detailing',
    category: 'ppf',
    description: 'Ceramic Pro certified installer specializing in paint protection film and ceramic coatings. Expert paint correction and vehicle protection.',
    location: 'Hooksett, NH',
    region: 'new-hampshire',
    coordinates: { lat: 43.2058, lng: -71.4688 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: false,
    specialties: [],
    services: ['PPF Installation', 'Ceramic Pro', 'Paint Correction', 'Protection Detail'],
    phone: null,
    website: 'https://imsdetailing.com',
    priceRange: '$$$',
    notes: 'Ceramic Pro certified PPF specialist'
  },
  {
    id: 'rmr-restorations',
    name: 'RMR Restorations',
    category: 'restoration',
    description: 'Established 1992 with 30+ years of classic car restoration expertise. Specializes in frame-off restorations of classic and muscle cars.',
    location: 'Hollis, NH',
    region: 'new-hampshire',
    coordinates: { lat: 42.7300, lng: -71.6126 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: true,
    specialties: ['Classic American', 'Muscle cars'],
    services: ['Frame-Off Restoration', 'Mechanical Rebuild', 'Body/Paint', 'Chrome'],
    phone: '(603) 465-7270',
    website: 'https://restorationmotors.com',
    priceRange: '$$$',
    notes: 'Est. 1992, 30+ years classic car restoration'
  },
  {
    id: 'car-one-auto-body',
    name: 'Car-One Auto Body',
    category: 'restoration',
    description: '8,000 sq ft facility specializing in frame-off restorations and custom paint for classic and show cars. State-of-the-art equipment.',
    location: 'Salem, NH',
    region: 'new-hampshire',
    coordinates: { lat: 42.7822, lng: -71.1920 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: false,
    specialties: ['Classic American', 'Show cars'],
    services: ['Frame-Off Restoration', 'Custom Paint', 'Body Work', 'Mechanical'],
    phone: '(603) 893-8400',
    website: 'https://caroneautobody.com',
    priceRange: '$$$',
    notes: '8,000 sq ft facility with frame-off restoration expertise'
  },
  {
    id: 'boyds-customs-classics',
    name: 'Boyds Customs and Classics',
    category: 'restoration',
    description: 'State-of-the-art restoration and custom fabrication facility. Specialists in classic and custom vehicle restoration with meticulous attention to detail.',
    location: 'Belmont, NH',
    region: 'new-hampshire',
    coordinates: { lat: 43.4586, lng: -71.5225 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: true,
    specialties: ['Classic American', 'Custom vehicles'],
    services: ['Full Restoration', 'Custom Fabrication', 'Paint', 'Mechanical'],
    phone: '(603) 568-3093',
    website: 'https://bccnh.com',
    priceRange: '$$$',
    notes: 'State-of-art restoration with custom fabrication'
  },
  {
    id: 'schena-auto-body',
    name: 'Schena Auto Body',
    category: 'bodywork',
    description: '30+ years of collision repair and classic restoration experience. Specializes in Porsche and Land Rover. Certified technicians with expertise in high-end vehicles.',
    location: 'Barrington, NH',
    region: 'new-hampshire',
    coordinates: { lat: 43.1925, lng: -71.3306 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: false,
    specialties: ['Porsche', 'Land Rover'],
    services: ['Collision Repair', 'Classic Restoration', 'Paint', 'Custom Work'],
    phone: '(603) 664-7215',
    website: 'https://schenaautobody.com',
    priceRange: '$$',
    notes: '30+ years, collision & classic restoration - Porsche/Land Rover specialist'
  },
  {
    id: 'synaptic-3-performance',
    name: 'Synaptic 3 Performance',
    category: 'performance',
    description: 'Dyno tuning and performance shop with heated storage available. Full fabrication services for performance vehicles.',
    location: 'Northwood, NH',
    region: 'new-hampshire',
    coordinates: { lat: 43.2783, lng: -71.3650 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: false,
    specialties: ['Performance vehicles'],
    services: ['Dyno Tuning', 'Fabrication', 'Heated Storage', 'Performance Work'],
    phone: '(603) 942-6009',
    website: 'https://synaptic3.com',
    priceRange: '$$',
    notes: 'Dyno tuning and heated storage for performance vehicles'
  },

  // === VERMONT ===
  {
    id: 'bullfrog-auto',
    name: 'Bullfrog Auto',
    category: 'mechanical',
    description: 'Independent Porsche specialist since 1997. Deep expertise in Porsche service and maintenance with trusted reputation among enthusiasts.',
    location: 'Williston, VT',
    region: 'vermont',
    coordinates: { lat: 44.4266, lng: -73.2162 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: true,
    specialties: ['Porsche'],
    services: ['Full Service', 'Maintenance', 'Repairs', 'Diagnostics'],
    phone: '(802) 578-5976',
    website: 'https://bullfrogautovt.com',
    priceRange: '$$$',
    notes: 'Independent Porsche specialist since 1997'
  },
  {
    id: 'sterling-motorwerks',
    name: 'Sterling Motorwerks',
    category: 'mechanical',
    description: 'Vermont\'s premier German car shop since 2010. Factory-trained technicians with R8 training. Full service for Audi, VW, BMW, Mini, Mercedes, and Porsche.',
    location: 'South Burlington, VT',
    region: 'vermont',
    coordinates: { lat: 44.4597, lng: -73.2273 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: true,
    specialties: ['Audi', 'VW', 'BMW', 'Mini Cooper', 'Mercedes-Benz', 'Porsche'],
    services: ['Factory Service', 'Diagnostics', 'Major Repairs', 'Performance'],
    phone: '(802) 489-5950',
    website: 'https://sterlingmotorwerks.com',
    priceRange: '$$$',
    notes: 'Vermont\'s German car specialist since 2010 - R8 trained'
  },
  {
    id: 'rpm-vermont',
    name: 'RPM Vermont',
    category: 'restoration',
    description: 'Family-owned for 40 years specializing in Ferrari and exotic car restoration. World-class expertise in rare and valuable vehicles.',
    location: 'Vergennes, VT',
    region: 'vermont',
    coordinates: { lat: 44.1639, lng: -73.2662 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: true,
    specialties: ['Ferrari', 'Porsche', 'Jaguar', 'Aston Martin'],
    services: ['Full Restoration', 'Exotic Service', 'Documentation', 'Concours Prep'],
    phone: '(802) 877-2645',
    website: 'https://rpmvt.com',
    priceRange: '$$$$',
    notes: 'Family-owned 40 years - Ferrari/exotic specialist'
  },
  {
    id: 'rennline-automotive',
    name: 'Rennline Automotive',
    category: 'performance',
    description: 'Aerospace-precision Porsche parts manufacturer and performance specialist. Custom fabrication and performance upgrades with OEM quality.',
    location: 'Milton, VT',
    region: 'vermont',
    coordinates: { lat: 44.6384, lng: -73.1550 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: true,
    specialties: ['Porsche', 'BMW', 'Audi'],
    services: ['Parts Manufacturing', 'Performance Tuning', 'Custom Fabrication', 'Upgrades'],
    phone: null,
    website: 'https://rennline.com',
    priceRange: '$$$',
    notes: 'Aerospace-precision Porsche parts manufacturer'
  },

  // === RHODE ISLAND ===
  {
    id: 'kane-motorcar-company',
    name: 'Kane Motorcar Company',
    category: 'restoration',
    description: 'Established 1969 specializing in exotic and vintage European car restoration. Museum-quality work on rare and significant vehicles.',
    location: 'North Kingstown, RI',
    region: 'rhode-island',
    coordinates: { lat: 41.5603, lng: -71.4706 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: true,
    specialties: ['European', 'Exotic', 'Vintage'],
    services: ['Full Restoration', 'Preservation', 'Concours Prep', 'Documentation'],
    phone: '(401) 294-4634',
    website: 'https://kanemotorcar.com',
    priceRange: '$$$$',
    notes: 'Est. 1969, exotic vintage restoration'
  },
  {
    id: 'protech-automotive-services',
    name: 'Protech Automotive Services',
    category: 'mechanical',
    description: 'Family-owned European vehicle specialist since 2010. Expert service for Audi, BMW, Mercedes, Porsche, and Volkswagen with fair pricing.',
    location: 'Johnston, RI',
    region: 'rhode-island',
    coordinates: { lat: 41.9439, lng: -71.4642 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: false,
    specialties: ['Audi', 'BMW', 'Mercedes-Benz', 'Porsche', 'VW'],
    services: ['Full Service', 'Diagnostics', 'Repairs', 'Maintenance'],
    phone: '(401) 464-9900',
    website: 'https://protechservice.com',
    priceRange: '$$$',
    notes: 'Family-owned European specialist since 2010'
  },
  {
    id: 'newport-car-storage',
    name: 'Newport Car Storage',
    category: 'storage',
    description: '30,000+ square feet of premium storage space with 24/7 surveillance. Located near Newport, ideal for exotic and classic vehicle owners.',
    location: 'Portsmouth, RI',
    region: 'rhode-island',
    coordinates: { lat: 41.5926, lng: -71.3169 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: false,
    specialties: [],
    services: ['Secure Storage', '24/7 Surveillance', 'Climate Control', 'Access'],
    phone: '(401) 835-2371',
    website: 'https://ncmcarstorage.com',
    priceRange: '$$$',
    notes: '30,000+ sq ft, 24/7 surveillance near Newport'
  },
  {
    id: 'quonset-motor-sport',
    name: 'Quonset Motor Sport',
    category: 'storage',
    description: '40,000 square feet of state-of-the-art storage rated for Category 5 hurricanes. Premium facility for exotic, classic, and high-performance vehicles.',
    location: 'North Kingstown, RI',
    region: 'rhode-island',
    coordinates: { lat: 41.5603, lng: -71.4706 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: true,
    specialties: [],
    services: ['Secure Storage', 'Climate Control', 'Security', 'Access'],
    phone: '(401) 667-0746',
    website: 'https://qmsri.com',
    priceRange: '$$$$',
    notes: '40,000 sq ft, Category 5 hurricane-rated'
  },

  // === CONNECTICUT (new entries) ===
  {
    id: 'innovative-restorations',
    name: 'Innovative Restorations',
    category: 'restoration',
    description: 'Full restoration facility with paint booth, machine shop, and rotisserie. Specializes in classic, vintage, and muscle car restorations.',
    location: 'Wallingford, CT',
    region: 'connecticut',
    coordinates: { lat: 41.4570, lng: -72.8231 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: true,
    specialties: ['Classic American', 'Vintage', 'Muscle cars'],
    services: ['Full Restoration', 'Paint Booth Work', 'Machine Shop', 'Rotisserie'],
    phone: '(860) 852-3275',
    website: 'https://innovativeresto.com',
    priceRange: '$$$$',
    notes: 'Full facilities with paint booth, machine shop, rotisserie'
  },
  {
    id: 'enfield-auto-restoration',
    name: 'Enfield Auto Restoration',
    category: 'restoration',
    description: 'Operating since 1972 with 15,000 square feet of restoration space. Specializes in antique, classic, and sports car restoration.',
    location: 'Enfield, CT',
    region: 'connecticut',
    coordinates: { lat: 41.9813, lng: -72.5544 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: true,
    specialties: ['Antique', 'Classic American', 'Sports cars'],
    services: ['Full Restoration', 'Body Work', 'Mechanical', 'Paint'],
    phone: '(860) 749-7917',
    website: 'https://enfieldautorestoration.com',
    priceRange: '$$$$',
    notes: 'Operating since 1972, 15,000 sq ft'
  },
  {
    id: 'sst-auto',
    name: 'SST Auto (Speedsport Tuning)',
    category: 'mechanical',
    description: '30+ years of multi-brand specialist expertise. Factory-trained for over 12 different luxury and performance brands including Porsche, Audi, BMW, Mercedes, Lamborghini, Bentley, and Aston Martin.',
    location: 'Danbury, CT',
    region: 'connecticut',
    coordinates: { lat: 41.3948, lng: -73.4540 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: true,
    specialties: ['Porsche', 'Audi', 'BMW', 'Mercedes-Benz', 'Lamborghini', 'Bentley', 'Aston Martin'],
    services: ['Full Service', 'Diagnostics', 'Repairs', 'Performance Upgrades'],
    phone: '(203) 730-0311',
    website: 'https://sstauto.com',
    priceRange: '$$$',
    notes: '30+ years, 12+ brand specialist'
  },
  {
    id: 'darien-detail-new',
    name: 'Darien Detail',
    category: 'ppf',
    description: 'XPEL certified paint protection film installer since 2013. Specializes in luxury and exotic vehicles with expert application and service.',
    location: 'Darien, CT',
    region: 'connecticut',
    coordinates: { lat: 41.0779, lng: -73.4696 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: true,
    specialties: [],
    services: ['XPEL PPF', 'Ceramic Coating', 'Paint Protection', 'Detail Services'],
    phone: '(203) 309-0708',
    website: 'https://dariendetail.com',
    priceRange: '$$$',
    notes: 'XPEL certified PPF installer since 2013'
  },

  // === MASSACHUSETTS (new entries) ===
  {
    id: 'autohaus-of-boston',
    name: 'Autohaus of Boston',
    category: 'mechanical',
    description: 'Factory-certified Ferrari and exotic vehicle repair specialist with 40+ years of experience. Top-tier service for the most demanding clientele.',
    location: 'Braintree, MA',
    region: 'massachusetts',
    coordinates: { lat: 42.2034, lng: -71.0234 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: true,
    specialties: ['Ferrari', 'Lamborghini', 'Maserati'],
    services: ['Exotic Service', 'Factory Repair', 'Diagnostics', 'Major Work'],
    phone: '(800) 678-8224',
    website: 'https://autohausofboston.com',
    priceRange: '$$$$',
    notes: 'Factory-certified Ferrari/exotic repair, 40+ years'
  },
  {
    id: 'independent-ferrari-service',
    name: 'Independent Ferrari Service',
    category: 'mechanical',
    description: 'Exclusive Ferrari specialist providing dedicated service to Ferrari owners. Expert technicians with Ferrari factory knowledge.',
    location: 'South Easton, MA',
    region: 'massachusetts',
    coordinates: { lat: 42.0589, lng: -71.1233 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: true,
    specialties: ['Ferrari'],
    services: ['Complete Ferrari Service', 'Diagnostics', 'Maintenance', 'Repairs'],
    phone: '(508) 238-4224',
    website: 'https://ifsferrari.com',
    priceRange: '$$$$',
    notes: 'Exclusive Ferrari specialist'
  },
  {
    id: 'paul-russell-company',
    name: 'Paul Russell & Company',
    category: 'restoration',
    description: 'World-renowned restoration specialist since 1978. Pebble Beach winners with museum-quality work on Mercedes, Ferrari, Porsche, Bugatti, and Alfa Romeo.',
    location: 'Essex, MA',
    region: 'massachusetts',
    coordinates: { lat: 42.6263, lng: -70.7766 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: true,
    specialties: ['Mercedes-Benz', 'Ferrari', 'Porsche', 'Bugatti', 'Alfa Romeo'],
    services: ['Concours Restoration', 'Preservation', 'Show Prep', 'Documentation'],
    phone: null,
    website: 'https://paulrussell.com',
    priceRange: '$$$$',
    notes: 'World-renowned since 1978 - Pebble Beach winners'
  },
  {
    id: 'boston-mechanics',
    name: 'Boston Mechanics',
    category: 'mechanical',
    description: 'European auto repair and performance upgrade specialist. Expertise in Mercedes, BMW, and Audi with modern diagnostic equipment.',
    location: 'Canton, MA',
    region: 'massachusetts',
    coordinates: { lat: 42.1675, lng: -71.1842 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: false,
    specialties: ['Mercedes-Benz', 'BMW', 'Audi'],
    services: ['Full Service', 'Performance Upgrades', 'Diagnostics', 'Repairs'],
    phone: '(781) 762-8850',
    website: 'https://boston-mechanics.com',
    priceRange: '$$$',
    notes: 'European auto repair and performance upgrades'
  },
  {
    id: 'eastside-motoring',
    name: 'Eastside Motoring',
    category: 'performance',
    description: 'Performance upgrade specialist offering wheels, tuning, wraps, and custom modifications. Expertise in European and domestic high-performance vehicles.',
    location: 'Waltham, MA',
    region: 'massachusetts',
    coordinates: { lat: 42.3736, lng: -71.2355 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: false,
    specialties: ['European', 'Domestic performance'],
    services: ['Performance Tuning', 'Wheel Install', 'Custom Wraps', 'Upgrades'],
    phone: '(781) 894-9333',
    website: 'https://eastsidemotoring.com',
    priceRange: '$$$',
    notes: 'Wheels, tuning, wraps, performance upgrades'
  },

  // === NEW YORK (new entries) ===
  {
    id: 'rd-automotive',
    name: 'R&D Automotive (Bavarian Rocket Scientists)',
    category: 'mechanical',
    description: 'Factory-trained specialist since 1982. Expert in Porsche, Audi, BMW, Mercedes, and Volkswagen with modern diagnostics and authentic expertise.',
    location: 'Albany, NY',
    region: 'albany-ny',
    coordinates: { lat: 42.6526, lng: -73.7562 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: true,
    specialties: ['Porsche', 'Audi', 'BMW', 'Mercedes-Benz', 'VW'],
    services: ['Factory Service', 'Diagnostics', 'Major Repairs', 'Maintenance'],
    phone: '(518) 598-1273',
    website: 'https://bavarianrocketscience.com',
    priceRange: '$$$',
    notes: 'Factory-trained since 1982'
  },
  {
    id: 'cantech-north-syracuse',
    name: 'Cantech Automotive',
    category: 'mechanical',
    description: '25+ years of expertise in Ferrari and exotic vehicles. Full service facility with Ferrari specialist knowledge and fair pricing.',
    location: 'North Syracuse, NY',
    region: 'syracuse-ny',
    coordinates: { lat: 43.1087, lng: -76.0950 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: false,
    specialties: ['Ferrari', 'BMW', 'Porsche', 'Mercedes-Benz', 'Audi', 'Land Rover'],
    services: ['Complete Service', 'Exotic Repair', 'Diagnostics', 'Maintenance'],
    phone: '(315) 452-1168',
    website: 'https://cantechautomotive.com',
    priceRange: '$$$',
    notes: '25+ years, Ferrari specialist'
  },
  {
    id: 'notorious-auto-protection',
    name: 'Notorious Auto Protection',
    category: 'ppf',
    description: 'XPEL certified installer specializing in paint protection film, ceramic coatings, and vehicle wraps. Focus on high-end vehicles.',
    location: 'Syracuse, NY',
    region: 'syracuse-ny',
    coordinates: { lat: 43.0481, lng: -76.1474 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: false,
    specialties: [],
    services: ['XPEL PPF', 'Ceramic Coating', 'Vehicle Wraps', 'Paint Protection'],
    phone: '(315) 552-4441',
    website: 'https://notoriousautoprotection.com',
    priceRange: '$$$',
    notes: 'XPEL certified - PPF/ceramic/wraps specialist'
  },
  {
    id: 'horsepower-motorworks',
    name: 'Horsepower Motorworks',
    category: 'restoration',
    description: '40+ years specializing in classic and vintage muscle car restoration. Climate-controlled storage and full restoration services.',
    location: 'Victor, NY',
    region: 'rochester-ny',
    coordinates: { lat: 43.2196, lng: -77.4129 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: true,
    specialties: ['Classic American', 'Vintage', 'Muscle cars'],
    services: ['Full Restoration', 'Storage', 'Mechanical Work', 'Paint'],
    phone: '(585) 330-4485',
    website: 'https://horsepowermotorworks.com',
    priceRange: '$$$',
    notes: '40+ years, climate-controlled storage included'
  },

  // === NEW JERSEY (new entries) ===
  {
    id: 'top-gear-exotics',
    name: 'Top Gear Exotics',
    category: 'mechanical',
    description: 'Established 2016 specializing in exotic vehicle service. Expert technicians with knowledge of BMW, Ferrari, Lamborghini, Porsche, and Maserati.',
    location: 'Ledgewood, NJ',
    region: 'central-nj',
    coordinates: { lat: 40.8500, lng: -74.6500 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: false,
    specialties: ['BMW', 'Ferrari', 'Lamborghini', 'Porsche', 'Maserati'],
    services: ['Exotic Service', 'Diagnostics', 'Repairs', 'Maintenance'],
    phone: '(862) 254-2275',
    website: 'https://topgearexotics.com',
    priceRange: '$$$',
    notes: 'Est. 2016, exotic vehicle specialist'
  },
  {
    id: 'autocouture-motoring',
    name: 'AUTOcouture Motoring',
    category: 'performance',
    description: '13,000 square foot facility specializing in BMW performance and tuning. Also services Audi, Porsche, McLaren, and Lamborghini with expert technicians.',
    location: 'Fair Lawn, NJ',
    region: 'central-nj',
    coordinates: { lat: 40.9555, lng: -74.1310 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: true,
    specialties: ['BMW', 'Audi', 'Porsche', 'McLaren', 'Lamborghini'],
    services: ['Performance Tuning', 'Service', 'Diagnostics', 'Upgrades'],
    phone: '(201) 666-3500',
    website: 'https://autocouturemotoring.com',
    priceRange: '$$$',
    notes: '13,000 sq ft, BMW specialist'
  },
  {
    id: 'palma-classic-cars',
    name: 'Palma Classic Cars',
    category: 'restoration',
    description: 'Established 1980 with specialized expertise in Rolls-Royce and Bentley restoration and service. Premium classic car specialists.',
    location: 'Audubon, NJ',
    region: 'south-nj',
    coordinates: { lat: 39.8378, lng: -75.1188 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: true,
    specialties: ['Rolls-Royce', 'Bentley'],
    services: ['Full Restoration', 'Service', 'Maintenance', 'Documentation'],
    phone: '(856) 406-5320',
    website: 'https://palmaclassiccars.com',
    priceRange: '$$$$',
    notes: 'Est. 1980, Rolls-Royce/Bentley specialist'
  },
  {
    id: 'exoticars-usa-milford',
    name: 'Exoticars USA',
    category: 'mechanical',
    description: 'Industry leader since 1979 specializing in Ferrari, Maserati, Lamborghini, Porsche, and Aston Martin service. Trusted by exotic car owners throughout the region.',
    location: 'Milford, NJ',
    region: 'south-nj',
    coordinates: { lat: 40.7760, lng: -74.7647 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: true,
    specialties: ['Ferrari', 'Maserati', 'Lamborghini', 'Porsche', 'Aston Martin'],
    services: ['Exotic Service', 'Diagnostics', 'Repairs', 'Maintenance'],
    phone: '(888) 416-7160',
    website: 'https://exoticars-usa.com',
    priceRange: '$$$$',
    notes: 'Industry leader since 1979, exotic service'
  },
  {
    id: 'lomotion-auto',
    name: 'Lomotion Auto',
    category: 'mechanical',
    description: 'Hudson Valley\'s premier automotive boutique since 1984. Spacious 30-car showroom with full service department, performance upgrades, and indoor vehicle storage. Specialists in Corvettes, BMW, Porsche, and other special interest vehicles.',
    location: 'Poughkeepsie, NY',
    region: 'hudson-valley',
    coordinates: { lat: 41.6764, lng: -73.9046 },
    rating: null,
    reviewCount: 0,
    verified: true,
    featured: true,
    specialties: ['BMW', 'Porsche', 'Mercedes-Benz', 'Audi', 'Jaguar', 'Classic American'],
    services: ['Full Service', 'Performance Upgrades', 'Indoor Storage', 'Vehicle Sales', 'Appraisals'],
    phone: '(845) 471-5705',
    website: 'https://www.lomotionauto.com',
    priceRange: '$$$',
    notes: 'Est. 1984, 30-car showroom, indoor storage available'
  }
]

// Helper function to calculate distance between two coordinates (Haversine formula)
export function calculateDistance(lat1, lon1, lat2, lon2) {
  const R = 3959 // Earth's radius in miles
  const dLat = (lat2 - lat1) * Math.PI / 180
  const dLon = (lon2 - lon1) * Math.PI / 180
  const a =
    Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLon/2) * Math.sin(dLon/2)
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a))
  return R * c
}

// Find providers within a given radius of coordinates
export function findProvidersNear(lat, lng, radiusMiles = 50, filters = {}) {
  return SERVICE_PROVIDERS
    .map(provider => {
      if (!provider.coordinates) return null
      const distance = calculateDistance(lat, lng, provider.coordinates.lat, provider.coordinates.lng)
      if (distance > radiusMiles) return null
      return { ...provider, distance: Math.round(distance) }
    })
    .filter(Boolean)
    .filter(provider => {
      if (filters.category && filters.category !== 'all' && provider.category !== filters.category) return false
      if (filters.brand && !provider.specialties.includes(filters.brand)) return false
      return true
    })
    .sort((a, b) => a.distance - b.distance)
}

// Get providers by category
export function getProvidersByCategory(category) {
  if (category === 'all') return SERVICE_PROVIDERS
  return SERVICE_PROVIDERS.filter(p => p.category === category)
}

// Get providers by specialty (brand)
export function getProvidersBySpecialty(brand) {
  return SERVICE_PROVIDERS.filter(p => p.specialties.includes(brand))
}

// Get featured providers
export function getFeaturedProviders() {
  return SERVICE_PROVIDERS.filter(p => p.featured)
}
